export default __webpack_public_path__ + "static/media/milestone 1600.e4e0c202.svg";